import {
    BUDGET_HOME_PAGE_URL,
    DASHBOARDS_PAGE_URL,
    HOME_PAGE_URL,
} from 'components/App/components/routes';

/**
 * Helper to hide and show the hubspot chat element available on the app.
 * It directly opens the chat panel when enabled.
 */
export function toggleHubspotChat() {
    const element = document.getElementById(
        'hubspot-messages-iframe-container',
    );
    if (element !== null) {
        if (element.style.display !== 'block') {
            element.style.setProperty('display', 'block', 'important');
            // @ts-expect-error [TS migration] Was not detected by flow
            window.HubSpotConversations.widget.open();
        } else {
            element.style.setProperty('display', 'none', 'important');
            // @ts-expect-error [TS migration] Was not detected by flow
            window.HubSpotConversations.widget.close();
        }
    }
}

/**
 * Get the homepage for decision.
 * The homePageUrl state can be either decision or budget or a custom homepage url.
 * We make the assumption that the custom homepage url is part of decision.
 * @param homePageUrl can be either /home, /budget_home or a custom home page
 * @returns the homepage for decision
 */
export function getDecisionHome(homePageUrl: string) {
    if (![HOME_PAGE_URL, BUDGET_HOME_PAGE_URL].includes(homePageUrl)) {
        return homePageUrl;
    }
    return DASHBOARDS_PAGE_URL;
}

export const sideBarLogoDimensions = (hideLogo: boolean) => ({
    borderRadius: 4,
    width: 123,
    height: 100,
    maxWidth: hideLogo ? 0 : 123,
});

/**
 * Determines the appropriate URL for budget settings based on user access.
 *
 * @param isAdminCategories - Indicates whether the user has admin privileges for categories.
 * @param hasAccessCadrageGestion - Indicates whether the user has access to cadrage gestion.
 */
export const getBudgetSettingsUrl = (
    isAdminCategories: boolean,
    hasAccessCadrageGestion: boolean,
    isSupportUser: boolean,
): string => {
    if (isAdminCategories || isSupportUser) {
        return '/budget_admin/manage_projects';
    } else if (hasAccessCadrageGestion) {
        return '/budget_admin/manage_cadrage';
    } else {
        return '/budget_admin/manage_budget';
    }
};
